export default "__VITE_ASSET__BJt5Hofo__"